<div class="store ios">
  <a class="appStoreButton iosButton" href="https://apps.apple.com/us/app/arkheim-realms-at-war/id1462914755" angulartics2On="click" angularticsAction="downloadIos" angularticsCategory="download">
    <img src="assets/appStoreButtons/ios/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" width="222">
    <!-- <div class="comingSoon"><span i18n="ios-comingSoon@@ios-button.comingSoon">Coming soon</span></div> -->
  </a>
</div>
